<template>
  <div class='coursework-viewer__slide'>
    <iframe sandbox="allow-scripts allow-same-origin" frameBorder="0" :srcdoc="media.data.embed" style="width:100%;border:none;overflow:hidden;"
            @load='ready' onload='javascript:(function(o){o.style.height=o.contentWindow.document.body.scrollHeight+"px";}(this));'></iframe>
  </div>
</template>

<script>
  export default {
    props: {
      media: Object
    },
    methods: {
      ready(e) {
        this.$emit('ready', this.media.id)
      }
    },
    created() {
      this.$parent.slides.push(this);
    },
    mounted() {

    }
  }
</script>